'use strict';

angular.module('theme').directive('orderStickers', function ($window, StickersService) {
	return {
		restrict: 'E',
		templateUrl: 'component/order-stickers.html',
		scope: true,
		controller: function ($scope, CUSTOMER) {
			$scope.hasCustomer = !!CUSTOMER;

			$scope.ordered = false;
			$scope.requesting = false;

			$scope.order = function () {
				$scope.requesting = true;
				StickersService.order().then(function () {
					$scope.ordered = true;
					$scope.requesting = false;
				});
			};
		}
	};
});
